import { render, staticRenderFns } from "./ChinaMap.vue?vue&type=template&id=3e89fd4f&scoped=true"
import script from "./ChinaMap.vue?vue&type=script&lang=js"
export * from "./ChinaMap.vue?vue&type=script&lang=js"
import style0 from "./ChinaMap.vue?vue&type=style&index=0&id=3e89fd4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e89fd4f",
  null
  
)

export default component.exports